<template>
  <main class="relative min-h-screen shadow-lg">
    <router-view />
    <client-only>
      <BlSnackbarMv :active.sync="getSnackbar.isShown" :message="getSnackbar.message" :is-error="getSnackbar.isError" />
    </client-only>
  </main>
</template>

<script>
import {nativeBridge} from 'shared_js/native-bridge';
import {mapGetters} from 'vuex';
import ClientOnly from 'vue-client-only';
import BlSnackbarMv from '@bukalapak/bazaar-mweb-latest/dist/components/BlSnackbarMv';

export default {
  name: 'PrakerjaMobileApp',
  components: {
    ClientOnly,
    BlSnackbarMv,
  },
  data() {
    return {
      platform: window.location.origin?.includes('m.') ? 'bl_mobile_web' : 'bl_web',
    };
  },
  computed: {
    ...mapGetters(['getSnackbar']),
  },
  watch: {
    $route(next, prev) {
      this.$store.commit('setPreviousPage', prev);
    },
  },
  beforeMount() {
    this.hideNativeNavbar();
  },
  mounted() {
    this.$store.dispatch('courses/fetchPrakerjaComingSoonToggle', this.platform);
  },
  methods: {
    hideNativeNavbar() {
      const json = JSON.stringify({hidden: true});
      nativeBridge.exec('setTopBar', json);
    },
  },
};
</script>

<style lang="scss" scoped>
main {
  max-width: 480px;
  margin: 0 auto;
}
</style>
